// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2FFL1","inner":"Form_inner__1Dmr2","range":"Form_range__u1WiJ","name":"Form_name__3ge8T","actions":"Form_actions__6Ll-f"};